import React from "react";
import "./SignUp.css";
import "../Auth/Login.css";
import LoginLogo from "../../Components/Assets/images/logo2.png";
import { Link } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle";

function SignupSelect({ onBuyerSelect }) {
  useTitle("Sign Up - TrendBay");

  return (
    <div className="auth-page">
      <div className="auth-card">
        <a href="/">
          <img className="auth-logo" src={LoginLogo} alt="TrendBay" />
        </a>
        <h1 className="auth-heading">Join TrendBay</h1>
        <p className="auth-sub">How would you like to use TrendBay?</p>

        <div className="auth-role-grid">
          <button className="auth-role-card" onClick={onBuyerSelect}>
            <span className="auth-role-icon">🛒</span>
            <span className="auth-role-label">Buyer</span>
            <span className="auth-role-desc">
              Shop groceries, fashion & more
            </span>
          </button>
          <button
            className="auth-role-card"
            onClick={() =>
              window.open("https://sell.trendbayds.com/signup", "_blank")
            }
            disabled={true}
          >
            <span className="auth-role-icon">🏪</span>
            <span className="auth-role-label">Seller</span>
            <span className="auth-role-desc">List & sell your products</span>
          </button>
        </div>

        <div className="auth-divider">already have an account?</div>
        <Link to="/login" className="auth-btn-outline">
          Sign In
        </Link>
      </div>
    </div>
  );
}

export default SignupSelect;
